import { Contract } from '~/data';

const getContractPath = (contract: Pick<Contract, 'contractNumber'>): string => {
  return `contracts/${contract.contractNumber}`;
};

export default getContractPath;
